import t from '../../translate'
import Field from "../../components/Field";
import { useFormikContext } from 'formik'
import React from 'react'

function Experience ({ id, experienceMandatoryFields }) {
  let isRequired = false;

  return <div className={'domestic'}>
    <label
      htmlFor={`data.studies.job.experience.${id}.function`}>{t(
      'data.studies.job.experience.function')}{isRequired && <>*</>}</label>
    <Field type={'text'}
           id={`data.studies.job.experience.${id}.function`}
           name={`data.studies.job.experience.${id}.function`}
           required={isRequired}/>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className={'form-row'}>
          <div className={'form-col'}>
            <label
              htmlFor={`data.studies.job.experience.${id}.start`}>{t(
              'data.studies.job.experience.start')}{isRequired &&
              <>*</>}</label>
            <Field type={'date'}
                   id={`data.studies.job.experience.${id}.start`}
                   name={`data.studies.job.experience.${id}.start`}
                   required={isRequired}/>
          </div>
          <div className={'form-col'}>
            <label
              htmlFor={`data.studies.job.experience.${id}.end`}>{t(
              'data.studies.job.experience.end')}{isRequired && <>*</>}</label>
            <Field type={'date'}
                   id={`data.studies.job.experience.${id}.end`}
                   name={`data.studies.job.experience.${id}.end`}
                   required={isRequired}/>
          </div>
        </div>
      </div>
    </div>
    <label
      htmlFor={`data.studies.job.experience.${id}.organization`}>{t(
      'data.studies.job.experience.organization')}{isRequired && <>*</>}</label>
    <Field type={'text'}
           id={`data.studies.job.experience.${id}.organization`}
           name={`data.studies.job.experience.${id}.organization`}
           required={isRequired}/>
  </div>
}

function Experiences ({ number }) {
  let { values, setFieldValue } = useFormikContext()
  let experiences = []
  if (values && values.data && values.data.studies && values.data.studies.job &&
    values.data.studies.job.experience) {
    experiences = values.data.studies.job.experience
  }
  let experienceNumber = experiences.length > 1 ? experiences.length : 1
  let canRemoveExperience = experienceNumber > 1

  function addExperience () {
    experiences.push({})
    setFieldValue('data.studies.job.experience', experiences)
  }

  function removeExperience () {
    if (canRemoveExperience) {
      experiences.pop()
      setFieldValue('data.studies.job.experience', experiences)
    }
  }

  const labelDelete = t('remove')

  return <>
    <h4>{number}) {t('data.studies.job.experiences.title')}</h4>
    <div className={'domestics'}>
      {((experienceNumber) => {
        let experiences = []
        for (let i = 0; i < experienceNumber; i++) {
          experiences.push(<Experience key={i} id={i}/>)
        }
        return experiences
      })(experienceNumber)}
    </div>
    <button className={'button'} type={'button'} onClick={addExperience}>{t(
      'add')}</button>
    {canRemoveExperience && <button type={'button'} className={'button'}
                                    onClick={removeExperience}>{labelDelete}</button>}
  </>
}

// function Education ({ number }) {
//   return <>
//     <label className={'h4'} htmlFor={'data.studies.job.education'}>{number}) {t(
//       'data.studies.job.education.title')}</label>
//     <Field
//       id="data.studies.job.education"
//       name="data.studies.job.education"
//       type="text"
//     />
//   </>
// }

// function CreditRelevantExperience ({ ns }) {
//   return <div className={'form-row'}>
//     <div className={'form-col'}>
//       <div className={'form-row'}>
//         <div className={'form-col'}>
//           <label htmlFor={ns + '.start'}>{t('data.studies.job.bonus.experience.start')}</label>
//           <Field
//             id={ns + '.start'}
//             name={ns + '.start'}
//             type="date"
//           />
//         </div>
//         <div className={'form-col'}>
//           <label htmlFor={ns + '.end'}>{t('data.studies.job.bonus.experience.end')}</label>
//           <Field
//             id={ns + '.end'}
//             name={ns + '.end'}
//             type="date"
//           />
//         </div>
//       </div>
//     </div>
//     <div className={'form-col'}>
//       <label htmlFor={ns + '.subject'}>{t('data.studies.job.bonus.experience.subject')}</label>
//       <Field
//         id={ns + '.subject'}
//         name={ns + '.subject'}
//         type="text"
//       />
//     </div>
//   </div>
// }

// function BonusCredits ({ number, type }) {
//   const labels = {
//     education: {
//       subject: t('data.studies.job.bonus.education.title'),
//       bonusTypeFull: t('data.studies.job.bonus.education.full',
//         { years: '1' }),
//       bonusTypeHalf: t('data.studies.job.bonus.education.half',
//         { years: '2' }),
//     },
//     training: {
//       subject: t('data.studies.job.bonus.training.title'),
//       bonusTypeFull: t('data.studies.job.bonus.training.full',
//         { years: '1,5' }),
//       bonusTypeHalf: t('data.studies.job.bonus.training.half',
//         { years: '3' }),
//     },
//   }
//   const { subject, bonusTypeFull, bonusTypeHalf } = labels[type]

//   return <>
//     <label htmlFor="data.studies.job.bonus.subject" className="h4">
//       {number}) {subject}
//     </label>
//     <Field
//       id="data.studies.job.bonus.subject"
//       name="data.studies.job.bonus.subject"
//       type="text"
//       className="form-control"
//       title={subject}
//     />
//     <div className="form-radio">
//       <Field
//         id={'data.studies.job.bonus.approvalRequested'}
//         name="data.studies.job.bonus.approvalRequested"
//         type="checkbox"
//       />
//       <label htmlFor={'data.studies.job.bonus.approvalRequested'}
//              className="form-radio-label">
//         {t('data.studies.job.bonus.approvalRequested')}
//       </label>
//     </div>
//     <div className="form-radio">
//       <Field
//         id={'data.studies.job.bonus.type.full'}
//         name="data.studies.job.bonus.type"
//         type="radio"
//         value={'fulltime'}
//       />
//       <label htmlFor={'data.studies.job.bonus.type.full'}
//              className="form-radio-label">
//         {bonusTypeFull}
//       </label>
//     </div>
//     <div className="form-radio">
//       <Field
//         id={'data.studies.job.bonus.type.half'}
//         name="data.studies.job.bonus.type"
//         type="radio"
//         value={'partTime'}
//       />
//       <label htmlFor={'data.studies.job.bonus.type.half'}
//              className="form-radio-label">
//         {bonusTypeHalf}
//       </label>
//     </div>
//     <div className="form-radio">
//       <Field
//         id={'data.studies.job.bonus.type.other'}
//         name="data.studies.job.bonus.type"
//         type="radio"
//         value={'other'}
//       />
//       <label htmlFor={'data.studies.job.bonus.type.other'}
//              className="form-radio-label">
//         {t('data.studies.job.bonus.other')}
//       </label>
//     </div>

//     <CreditRelevantExperience ns={'data.studies.job.bonus.experience.0'}/>
//     <CreditRelevantExperience ns={'data.studies.job.bonus.experience.1'}/>
//     <CreditRelevantExperience ns={'data.studies.job.bonus.experience.2'}/>
//   </>
// }

export default function Job ({ program }) {
  const {
    educationRequired,
    experienceMandatoryFields,
    experienceRequired,
    bonusCreditsType,
  } = program?.job ?? {}
  let i = 1

  return <>
    <Experiences experienceMandatoryFields={experienceMandatoryFields}
                   number={i++}/>
    <div className={'form-row mt-4'}>
      <div className={'form-col'}>
        <label
          htmlFor={`data.studies.job.furtherEducation`}>{t(
          'data.studies.job.furtherEducation')}</label>
        <Field type={'text'}
                id={`data.studies.job.furtherEducation`}
                name={`data.studies.job.furtherEducation`}/>
      </div>
    </div>
    {/* {experienceRequired &&
      <Experiences experienceMandatoryFields={experienceMandatoryFields}
                   number={i++}/>}
    {educationRequired && <Education number={i++}/>}
    {bonusCreditsType && (
      <BonusCredits number={i++} type={bonusCreditsType}/>
    )} */}
  </>
}